import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-car',
  templateUrl: './map-car.component.html',
  styleUrls: ['./map-car.component.scss']
})
export class MapCarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
